import React from 'react';
import useMaintenance from '../../hooks/useMaintenance';
import MaintenancePage from './MaintenancePage';

/**
 * Wrap any content with <MaintenanceGate> to block it when maintenance is ON.
 *
 * Props:
 * - page: optional custom component to render during maintenance
 * - endpoint: override backend endpoint (default: /api/maintenance-status)
 * - pollMs: set to >0 to keep checking status while user is on the page
 */
export default function MaintenanceGate({ children, page: Page = MaintenancePage, endpoint, pollMs = 0, transform }) {
  const { maintenance, loading, message } = useMaintenance({ endpoint, pollMs, transform });

  if (loading) return null; // keep existing loader behavior
  if (maintenance) return <Page message={message || undefined} />;
  return <>{children}</>;
}
